import { render, staticRenderFns } from "./Whybox.vue?vue&type=template&id=20b74d8e&"
import script from "./Whybox.vue?vue&type=script&lang=js&"
export * from "./Whybox.vue?vue&type=script&lang=js&"
import style0 from "./Whybox.vue?vue&type=style&index=0&id=20b74d8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports